import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { getThemeVars } from './themeTokens';

const ThemeContext = createContext({
  mode: 'light',
  accent: 'burntBanksia',
  setMode: () => {},
  setAccent: () => {},
});

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState('dark');
  const [accent, setAccent] = useState('burntBanksia');

  useEffect(() => {
    const savedMode = localStorage.getItem('mudo:themeMode');
    const savedAccent = localStorage.getItem('mudo:themeAccent');
    if (savedMode === 'light' || savedMode === 'dark') setMode(savedMode);
    if (savedAccent) setAccent(savedAccent);
  }, []);

  useEffect(() => {
    const vars = getThemeVars(mode, accent);
    const root = document.documentElement;
    Object.entries(vars).forEach(([k, v]) => {
      root.style.setProperty(k, v);
    });
    localStorage.setItem('mudo:themeMode', mode);
    localStorage.setItem('mudo:themeAccent', accent);
  }, [mode, accent]);

  const value = useMemo(() => ({ mode, accent, setMode, setAccent }), [mode, accent]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}

export default ThemeProvider;
